import ThemeButton from "../theme-button/ThemeButton";
import styles from "./secondary-button.module.scss";

export const SecondaryButton = ({ className, disabled, ...restProps }) => {
  return (
    <ThemeButton
      {...restProps}
      disabled={disabled}
      className={`${disabled ? "" : styles.secondaryButton} ${className}`}
    />
  );
};

export default SecondaryButton;
